import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {  faInfoCircle } from '@fortawesome/free-solid-svg-icons';

const Card = ({ image, title, sub, text, setModalContent, setModalOpen }) => {
  const handleClickInfo = () => {
    setModalContent({ title: title, sub: sub, image: image, text: text });
    setModalOpen(true);
  };
  return (
    <>
      <div className="col">
        <Container className="card bg-dark gray-border">
          <ImgContainer>
            <Img className="card-img-top" src={image} alt=""></Img>
          </ImgContainer>

          <div className="card-body">
            <a
              className="text-light link-info bg-info text-decoration-none"
              href="#"
            >
              <Title className="fs-5 mb-0 heading fw-bold">{title}</Title>
            </a>
            <P className="text-light text-muted mb-2 lead">{sub}</P>
            <div className="d-flex justify-content-center">
            <NeonButton onClick={handleClickInfo} className="float-right">
                <FontAwesomeIcon icon={faInfoCircle} /> {' '}More Info 
            </NeonButton>
            </div>
          </div>
        </Container>
      </div>
    </>
  );
};
export default Card;
const Container = styled.div`
  border-radius: 12px;
  transition: box-shadow 0.25s, border-color 0.25s;
  border: 1px solid rgba(174, 234, 255, 0.18);
  background: #181830 !important; /* force solid background */
  box-shadow: 0 2px 16px 0 rgba(0,0,0,0.18);
  /* fallback for browsers: */
  background-color: #181830 !important;
  
  &:hover, &:focus-within {
    box-shadow: 0 0 12px 2px #aeeaff;
    border-color: #aeeaff;
  }
`;
const ImgContainer = styled.div`
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  min-height: 100%; /* or any specific value as per your design */
  width: 100%;
  height: auto;
  overflow: hidden;
`;
const Img = styled.img`
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  min-height: 100%;
  width: 100%;
  height: auto;
  overflow: hidden;
`;
const Title = styled.h2`
  margin: 0;
  padding: 0; /* Set the maximum number of lines for the title */

  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  
  -webkit-line-clamp: 3; /*  allows only 3 lines */
  -webkit-box-orient: vertical;
  white-space: normal;
  min-height: 2em;
`;
const P = styled.p`
  margin: 0;
  padding: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3; /*  max hight only 3 lines */
  -webkit-box-orient: vertical;
  white-space: normal;

  min-height: 4em; /* min hight 3 lines */
`;
const NeonButton = styled.button`
  background: #aeeaff;
  color: #222;
  border: none;
  border-radius: 8px;
  padding: 0.5rem 1.2rem;
  font-weight: bold;
  box-shadow: 0 0 0px #aeeaff;
  transition: box-shadow 0.2s, background 0.2s, color 0.2s;
  outline: none;
  margin-top: 0.5rem;
  cursor: pointer;

  &:hover, &:focus {
    background: #e0f7ff;
    color: #111;
    box-shadow: 0 0 10px 2px #aeeaff;
  }
`;
